import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Button } from "@mui/material";
import BasicModal from "./BasicModal";
import { collection, getCountFromServer, getFirestore, onSnapshot, getDocs, query, where } from '@firebase/firestore';
import {  db } from "./firebase";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { createTheme } from '@mui/material/styles';

import ModeIcon from '@mui/icons-material/Mode';
import Badge from 'react-bootstrap/Badge';
// import NewPatientModal from "./NewPatientModal.jsx";
import { useAuth } from "./authContext";



const OpenModalButton = ({ row }) => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Button onClick={handleOpen}>
        <ModeIcon></ModeIcon>


      </Button>
      <BasicModal
        open={open}
        onOpen={handleOpen}
        onClose={handleClose}
        row={row}
      />
    </>
  );
};


// const rows = [
//   { id: 1, col1: "Hello", col2: "World" },
//   { id: 2, col1: "MUI X", col2: "is awesome" }
// ];

const columns = [
  { field: 'propertyName', headerName: 'Address', width: 200 },
    { field: 'currentRent', headerName: 'Current Rent', width: 130 },
    { field: 'marketRent', headerName: 'Market Rent', width: 130 },
    { field: 'purchasePrice', headerName: 'Purchase Price', width: 150 },
    { field: 'totalDownPayment', headerName: 'Down Payment', width: 150 },
    { field: 'interestRate', headerName: 'Interest Rate', width: 140 },
    { field: 'term', headerName: 'Term (yr)', width: 90 },
   
   
  {
    field: "col2",
    headerName: "Details",
    width: 75,
    renderCell: OpenModalButton
  },
 

];

export default function ImportantTable() {
  const[rows, setRows] = useState([]);
  const { currentUser } = useAuth()

    const empCollectionRef = collection(db, 'users', currentUser.uid,'properties');
    const q = query(empCollectionRef);    
    const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [docs] = useCollectionData(empCollectionRef)
    console.log(docs)
    useEffect(()=> {
        getUsers()
    }, [])

  const getUsers = async() => {
      const data = await getDocs(q);

      // console.log(ydocs)
      setRows(data.docs.map((doc) => ({...doc.data(), id: doc.id})))
  }

  return (
    <div style={{ height: 800, width: "100%",   }}>
      <DataGrid sx={{boxShadow:2, background:'white'}} rows={rows} columns={columns} />
    </div>
  );
}
